import { gql } from '@apollo/client';

export const createAdminUser = gql`
    mutation ($id: String, $email: String!, $password: String, $roleId: Int!) {
        createAdminUser (id: $id, email: $email, password: $password, roleId: $roleId) {
        status
        errorMessage
        }
    }
    `;

export const deleteAdminUserMutation = gql`
    mutation ($id: String!) {
        deleteAdminUser (id: $id) {
        status
        errorMessage
        }
    }
    `;

export const getAdminUserQuery = gql`
    query {
        getAdminUser {
            id
            email
            isSuperAdmin
            roleId
            createdAt
            updatedAt
            adminRole {
                id
                privileges
            }
            status
            errorMessage
        }
    }
    `;
   
export const  getAllAdminUsers = gql`query($currentPage: Int) {
    getAllAdminUsers(currentPage: $currentPage) {
    results{
      id
      email
      isSuperAdmin
      roleId
      createdAt
      updatedAt
      adminRole {
        id
        name
        description
        createdAt
        updatedAt
        privileges
      }
    }
    }
  }`;

export const createAdminRole = gql`
    mutation ($id: Int, $name: String!, $description: String, $privileges: [Int]!) {
        createAdminRole (id: $id, name: $name, description: $description, privileges: $privileges) {
            status
            errorMessage
        }
    }
    `;

export const deleteAdminRoleMutation = gql`
    mutation ($id: Int!) {
        deleteAdminRole(id: $id) {
            status
            errorMessage
        }
    }
    `;